import { Injectable } from '@angular/core'
import { GEOSERVER_URL_GEOJSON } from '@core/constants/constant.data'
import { environment } from '@env/environment'

@Injectable({
  providedIn: 'root',
})
export class GeoServerService {
  getGeoServerUrl(
    layer: string,
    date_filter: string,
    nuts_ids: string,
    stat_level_filter?: string,
    epsg?: string,
  ) {
    let srsName = ''
    if (epsg) {
      srsName = `&srsName=EPSG:${epsg}`
    }
    const url =
      GEOSERVER_URL_GEOJSON +
      `?service=WFS&version=2.0.0&request=GetFeature${srsName}` +
      `&typeNames=${environment.prefixWorkspaceName}${layer}&outputFormat=application/json` +
      `&cql_filter=${date_filter}(${nuts_ids})${stat_level_filter}`
    return url
  }
}
